import React from 'react'
import PropTypes from 'prop-types'
import { ProductPrice, Link, ProductModal } from 'Blocks'
import { cutTitleToLimit, transformImageURL } from 'Utils'
import { PRODUCT } from 'Constants'

class EmbedProductCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false
    }
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleOpen() {
    if (!this.props.product.flags.isStocked) {
      this.setState({ modalOpen: true })
    }
  }

  handleClose() {
    this.setState({ modalOpen: false })
  }

  render() {
    const { product, className } = this.props

    let presentedProduct = product
    if (product === null) {
      presentedProduct = PRODUCT
    }

    const {
      affiliateUrl = '',
      brand = 'Brand',
      flags: { isDiscounted, isStocked },
      image,
      prices,
      title,
      uuid
    } = presentedProduct

    const transformedImage = transformImageURL(image, {
      crop: 'limit',
      width: 500
    })

    return (
      <div className={`${className} product`}>
        <Link
          to={affiliateUrl}
          target="_blank"
          rel="noopener noreferrer nofollow"
          childrenOnly={!isStocked}
        >
          <div onClick={this.handleOpen}>
            <div className="image-link">
              <div className="img-wrapper">
                <img alt={cutTitleToLimit(title)} src={transformedImage} />
              </div>
            </div>
            <div className="footer">
              <h4 className="brand">{cutTitleToLimit(brand, 20)}</h4>
              <h5>{cutTitleToLimit(title)}</h5>
              <ProductPrice {...{ isDiscounted, prices }} />
            </div>
          </div>
          <ProductModal
            variant="embedModal"
            itemsPerRow={this.props.itemsPerRow}
            on={this.state.modalOpen}
            close={this.handleClose}
            productUuid={uuid}
          />
        </Link>
      </div>
    )
  }
}

EmbedProductCard.displayName = 'EmbedProductCard'

EmbedProductCard.defaultProps = {
  itemIndex: 0,
  layoutIndex: 0,
  className: '',
  style: {},
  showProductName: true,
  screenType: 'large'
}

EmbedProductCard.propTypes = {
  className: PropTypes.string,
  itemIndex: PropTypes.number,
  itemsPerRow: PropTypes.any,
  layoutIndex: PropTypes.number,
  product: PropTypes.shape({
    flags: PropTypes.shape({
      isStocked: PropTypes.any
    })
  }),
  screenType: PropTypes.string,
  showProductName: PropTypes.bool,
  style: PropTypes.object
}

export default EmbedProductCard
